import React, { FC, SyntheticEvent, useMemo } from 'react';
import { Icon } from '@cld/icon';
import Typography from '@cld/typography';
import { Content, Label, Root } from './CollapsibleSection.styled';
import { SectionProps } from './Section';

/** Collapsible section component */
export const CollapsibleSection: FC<SectionProps> = ({ children, title, open, onToggle, className, horizontalPadding, verticalPadding }) => {
  const onDetailsToggle = useMemo(() => {
    if (!onToggle) {
      return undefined;
    }

    return (event: SyntheticEvent<HTMLDetailsElement>) => onToggle(event.currentTarget.open);
  }, [onToggle]);

  return (
    // TODO: onToggle seems to be missing from React types. Open PR?
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <Root className={className} open={open} onToggle={onDetailsToggle}>
      <Label data-test="section-label">
        <Typography size="xs" type="lowContrast">
          {title}
        </Typography>
        <Icon name="keyboardArrowDown" size="xs" />
      </Label>
      <Content data-test="section-content" horizontalPadding={horizontalPadding} verticalPadding={verticalPadding}>{children}</Content>
    </Root>
  );
};
